import React, { useState } from "react";
import "../styles/projetos.css";
import { projetos, Projeto } from "../data/projetos";

const Projetos: React.FC = () => {
  const [selectedPdf, setSelectedPdf] = useState<string | null>(null);
  const [selectedTitle, setSelectedTitle] = useState<string>("");

  // Check if device is mobile
  const isMobile = () => {
    return (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      ) || window.innerWidth <= 768
    );
  };

  const handleCardClick = (projeto: Projeto) => {
    if (isMobile()) {
      // On mobile, open PDF in new tab instead of modal
      window.open(projeto.pdfFile, "_blank");
    } else {
      // On desktop, show modal
      setSelectedPdf(projeto.pdfFile);
      setSelectedTitle(projeto.title);
    }
  };

  const handleDownload = (
    e: React.MouseEvent,
    pdfFile: string,
    title: string
  ) => {
    e.stopPropagation(); // Prevent card click
    const link = document.createElement("a");
    link.href = pdfFile;
    link.download = title;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const closePdfModal = () => {
    setSelectedPdf(null);
    setSelectedTitle("");
  };

  return (
    <div className="projetos-container">
      {/* Header */}
      <div className="projetos-header">
        <div className="projetos-header-text">
          <h1>TCCs</h1>
          <p>
            Trabalhos desenvolvidos no Laboratório de Representação Científica.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="projetos-content">
        <div className="projetos-grid">
          {projetos.map((projeto) => (
            <div
              key={projeto.id}
              className="projeto-card"
              onClick={() => handleCardClick(projeto)}
            >
              <div className="projeto-cover-container">
                <img
                  src={projeto.coverImage}
                  alt={`Capa do ${projeto.title}`}
                  className="projeto-cover"
                />
              </div>

              <div className="projeto-info">
                <h3 className="projeto-title">{projeto.title}</h3>

                {projeto.subtitle && (
                  <p className="projeto-subtitle">{projeto.subtitle}</p>
                )}

                {projeto.authors.length > 0 && (
                  <div className="projeto-authors">
                    <span className="projeto-authors-label">Autores: </span>
                    {projeto.authors.join(", ")}
                  </div>
                )}

                <div className="projeto-orientador">
                  <span className="projeto-orientador-label">Orientador: </span>
                  {projeto.orientador}
                </div>

                <div className="projeto-year">{projeto.year}</div>
              </div>

              <div className="projeto-actions">
                <button
                  className="download-button"
                  onClick={(e) =>
                    handleDownload(e, projeto.pdfFile, projeto.title)
                  }
                >
                  <svg
                    className="download-icon"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                  Baixar em PDF
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* PDF Modal */}
      {selectedPdf && (
        <div className="pdf-modal-overlay" onClick={closePdfModal}>
          <div
            className="pdf-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="pdf-modal-header">
              <h3 className="pdf-modal-title">{selectedTitle}</h3>
              <button className="pdf-modal-close" onClick={closePdfModal}>
                ×
              </button>
            </div>
            <div className="pdf-modal-body">
              {isMobile() ? (
                <div className="pdf-mobile-fallback">
                  <p>Para melhor visualização em dispositivos móveis:</p>
                  <a
                    href={selectedPdf}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="pdf-mobile-link"
                  >
                    Abrir PDF em nova aba
                  </a>
                </div>
              ) : (
                <iframe
                  src={selectedPdf}
                  className="pdf-iframe"
                  title={selectedTitle}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Projetos;
